
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M512 169.085v208.597c0 19.216-15.553 34.766-34.773 34.766H164.265c-19.222 0-34.774-15.551-34.774-34.766V134.318c0-19.217 15.554-34.766 34.774-34.766h312.962c19.221 0 34.773 15.55 34.773 34.766v34.767zm-191.071-12.182c-31.424 0-56.902 25.472-56.902 56.89 0 31.417 25.479 56.889 56.902 56.889s56.902-25.472 56.902-56.889c0-31.418-25.478-56.89-56.902-56.89zM220.341 374.306c0 .099 198.057.216 198.057 0 0-54.676-44.341-98.8-99.028-98.8s-99.029 44.124-99.029 98.8zM23.574 400.407C10.621 410.135 0 404.811 0 388.608V123.392c0-16.202 10.621-21.525 23.574-11.798l70.751 53.064c12.953 9.729 23.574 30.938 23.574 47.139v88.406c0 16.201-10.621 37.411-23.573 47.138l-70.752 53.066z"}})])
          )
        }
      }
    